(() => {
  'use strict';
  const dialog = document.querySelector('[data-ms-cart-retention]');
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.msRetentionBound === 'true') return;
  const back = dialog.querySelector('[data-ms-retention-back]');
  const offer = dialog.querySelector('[data-ms-retention-offer]');
  const clear = dialog.querySelector('[data-ms-retention-clear]');
  const error = dialog.querySelector('[data-ms-retention-error]');
  if (!back || !offer || !clear || !error) return;
  dialog.dataset.msRetentionBound = 'true';
  const rootSelector = '[data-msno-aa-fk7-v2][id^="MSNOAAFK7Root-"]';
  const memorySeen = new Set();
  let origin = null;
  let busy = false;
  let operation = 0;
  let replay = null;
  let pending = null;

  function snapshot() {
    try {
      const owner = window.MSNO_AA_FK8 || window.MSNO_AA_FK7;
      return owner && typeof owner.snapshot === 'function' ? owner.snapshot() : null;
    } catch (_) { return null; }
  }

  function usable(root, button, state) {
    if (!root || !root.isConnected || !button || !button.isConnected || button.disabled || button.hidden
      || button.getAttribute('aria-disabled') === 'true' || root.hidden
      || root.getAttribute('data-aa-open') !== 'true') return false;
    const scope = root.shadowRoot || root;
    if (scope.querySelector('[data-aa-empty]') !== button) return false;
    if (scope.querySelector('[data-aa-offer-form]:not([hidden])')
      || scope.querySelector('[data-aa-vendor-modal]:not([hidden])')
      || scope.querySelector('[data-aa-delivery-modal]:not([hidden])')) return false;
    if (!state) return !['cart_empty', 'calculating'].includes(root.getAttribute('data-aa-state'));
    if (!state.enabled || state.recovery !== 'READY' || !state.drawer_open
      || ['CART_EMPTY', 'CALCULATING'].includes(state.status)) return false;
    const locked = ['checkout_in_flight', 'offer_in_flight', 'cart_rebind_in_flight',
      'cart_line_mutation_in_flight', 'line_quantity_intent_pending', 'line_quantity_commit_in_flight',
      'line_quantity_submitting', 'pending_line_intent', 'empty_cart_in_flight', 'pending_empty_intent',
      'external_cart_operation_in_flight', 'cart_reconcile_in_flight', 'cart_rehydrate_in_flight'];
    return !locked.some(key => state[key] === true) && !(state.pending_mutations > 0)
      && !['PREPARING', 'MATERIALIZING'].includes(state.checkout_materialization_state);
  }

  function sessionKey(root) {
    const theme = window.Shopify && window.Shopify.theme && window.Shopify.theme.id;
    return `ms-cart-retention-shown-v1:${theme || root.getAttribute('data-aa-theme-id') || 'theme'}`;
  }

  function seen(key) {
    if (memorySeen.has(key)) return true;
    try { return window.sessionStorage.getItem(key) === '1'; } catch (_) { return false; }
  }

  function markSeen(key) {
    memorySeen.add(key);
    try { window.sessionStorage.setItem(key, '1'); } catch (_) {}
  }

  function setBusy(value) {
    busy = value;
    offer.disabled = value;
    clear.disabled = value;
    dialog.setAttribute('aria-busy', value ? 'true' : 'false');
  }

  function close(restoreFocus) {
    operation += 1;
    if (pending) pending.abort();
    pending = null;
    const previous = origin;
    origin = null;
    if (dialog.open) dialog.close();
    setBusy(false);
    error.hidden = true;
    if (restoreFocus && previous && previous.root.isConnected) {
      const scope = previous.root.shadowRoot || previous.root;
      const target = previous.button.isConnected && !previous.button.disabled ? previous.button : scope.querySelector('[data-aa-panel]');
      if (target && typeof target.focus === 'function') target.focus({preventScroll: true});
    }
  }

  function showError() {
    setBusy(false);
    error.hidden = false;
    back.focus({preventScroll: true});
  }

  document.addEventListener('click', event => {
    if (event.isTrusted !== true || replay || event.defaultPrevented) return;
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const button = path.find(node => node && typeof node.matches === 'function' && node.matches('[data-aa-empty]'));
    if (!button) return;
    const root = path.find(node => node && typeof node.matches === 'function' && node.matches(rootSelector));
    if (!root) return;
    if (dialog.open || busy) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const key = sessionKey(root);
    const bridge = window.MSNO_FK8_BRIDGE;
    if (seen(key) || !bridge || typeof bridge.waitForService !== 'function' || !usable(root, button, snapshot())) return;
    const scope = root.shadowRoot || root;
    const cart = scope.querySelector('[data-aa-cart]');
    if (!cart || cart.hidden) return;
    try {
      dialog.showModal();
    } catch (_) { return; }
    origin = {root, button};
    error.hidden = true;
    markSeen(key);
    event.preventDefault();
    event.stopImmediatePropagation();
    back.focus({preventScroll: true});
  }, true);

  back.addEventListener('click', () => close(true));
  dialog.addEventListener('cancel', event => {
    event.preventDefault();
    close(true);
  });

  offer.addEventListener('click', async () => {
    if (!dialog.open || !origin || busy) return;
    const selected = origin;
    const token = ++operation;
    setBusy(true);
    error.hidden = true;
    pending = typeof AbortController === 'function' ? new AbortController() : null;
    try {
      const bridge = window.MSNO_FK8_BRIDGE;
      if (!bridge || typeof bridge.waitForService !== 'function') throw new Error('UNAVAILABLE');
      const service = await bridge.waitForService({timeoutMs: 15000, ...(pending ? {signal: pending.signal} : {})});
      if (token !== operation || !dialog.open || origin !== selected) return;
      const state = typeof service.snapshot === 'function' ? service.snapshot() : snapshot();
      if (!service || typeof service.isOperational !== 'function' || !service.isOperational()
        || typeof service.prepareOffer !== 'function' || !usable(selected.root, selected.button, state)) throw new Error('UNAVAILABLE');
      close(false);
      await service.prepareOffer();
    } catch (_) {
      if (token === operation && dialog.open && origin === selected) showError();
    }
  });

  clear.addEventListener('click', () => {
    if (!dialog.open || !origin || busy) return;
    const selected = origin;
    if (!usable(selected.root, selected.button, snapshot())) {
      close(true);
      return;
    }
    setBusy(true);
    close(false);
    replay = selected.button;
    try { selected.button.click(); } finally { replay = null; }
  });
})();
